import { useContext, useEffect, useState } from "react";
import { Row, Col, Radio } from "antd";
import "../App.css";
import { LoadingOutlined } from "@ant-design/icons";
import { emptyStudio, Studio } from "./interfaces";
import EditStudioInfo from "./EditStudioInfo";
import { getStudio } from "./utils";
import { SignedInContext } from "../AppEnv";
import { SignedInDoctor } from "../auth/interfaces";
import AddNewDoctor from "./AddNewDoctor";
import { Console } from "console";

const StudioAdmin = () => {
  const [studio, setStudio] = useState(emptyStudio);
  const [loading, setLoading] = useState(true);
  const signedInDoctor: SignedInDoctor =
    useContext(SignedInContext).signedInDoctor;

  const [masterD, setMasterD] = useState(false);

  const selExamsEditOptions = [
    { value: "add-doctor", label: "Team Dottori" },
    { value: "edit-studio", label: "Dati Studio" },
  ];

  const [selExamsEdit, setSelExamsEdit] = useState(
    selExamsEditOptions[0].value
  );

  useEffect(() => {
    if (signedInDoctor.studioMaster == true) setMasterD(true);
    else setMasterD(false);
  }, [signedInDoctor]);

  /* useEffect(() => {
    setMasterD(signedInDoctor.studioMaster === true);
  }, [signedInDoctor]); 

  console.log(" DOC IS: " + signedInDoctor.studioMaster); */

  useEffect(() => {
    getStudio(signedInDoctor)
      .then((fetchedStudio: Studio) => {
        setStudio({
          ...fetchedStudio,
        });
      })
      .catch((err) => console.error(err));
  }, [signedInDoctor]);

  useEffect(() => {
    if (studio.id != undefined && studio.id >= 0) {
      studio.telephoneD =
        studio.telephone != undefined &&
        studio.telephone.length == 13 &&
        studio.telephone[0] == "+"
          ? studio.telephone.substring(3) //delete prefix from visualization, e.g. +39
          : studio.telephone;
      studio.websiteD =
        studio.website != undefined && studio.website.startsWith("http://")
          ? studio.website.substring("http://".length) //delete prefix from visualization, e.g. +39
          : studio.website;
      setLoading(false);
    }
  }, [studio]);

  return (
    <>
      <div className="centered">
        <h3 className="section-title">
          {loading && <LoadingOutlined rev={undefined} />}
          {studio.fullName}
        </h3>
      </div>

      <Col span={1}></Col>
      <Row style={{ marginBottom: "2%", marginLeft: "5%" }}>
        <Radio.Group
          onChange={(e) => setSelExamsEdit(e.target.value)}
          options={selExamsEditOptions}
          value={selExamsEdit}
          defaultValue={selExamsEdit}
          optionType="button"
          buttonStyle="solid"
        />
      </Row>

      {selExamsEdit == "edit-studio" && (
        <>
          <Col span={20} style={{ marginBottom: "2%", marginLeft: "5%" }}>
            <EditStudioInfo baseStudio={studio} setBaseStudio={setStudio} />
          </Col>
          <Col span={1}></Col>
        </>
      )}

      {selExamsEdit == "add-doctor" && (
        <>
          <Col span={24}>
            <AddNewDoctor baseStudio={studio} setBaseStudio={setStudio} />
          </Col>
          <Col span={1}></Col>
        </>
      )}
    </>
  );
};

export default StudioAdmin;
